import React, { Component } from 'react';
import { Link  } from 'react-router-dom';
import './index.css';
import { encodeforspace } from '../../utils/helper';
import { cities } from '../../common/const'
// import AdSense from 'react-adsense';

const location = {
  city: cities,
  state: ['AZ', 'CA', 'CO', 'FL', 'GA', 'ID', 'IL', 'MA', 'MI', 'MN', 'NY', 'OH', 'OR', 'PA', 'TN', 'TX', 'UT', 'WA'],
  country: ['UK', 'Canada', 'Australia', 'India', 'Finland'],
  industry: [ 'Fintech', 'EdTech', 'Analytics', 'Digital Health', 'Martech', 'AdTech', 'BioTech', 'DevOps', 'Tech Services', 'Real Estate', 'Cannabis']
}

import { Row, Col } from 'reactstrap';
// import { GooglePublisherTags } from '../../views/GooglePublisherTags';
class Footer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showAd: false,
      env: process.env.NODE_ENV || 'development',
    }

  }

  componentWillReceiveProps(nextprops, nextstate) {
    // if (typeof ezstandalone !== 'undefined' &&  (window && window.location.pathname) !== '/') {
    //   setTimeout(()=>{
    //     console.log('r')
    //     ezstandalone.refresh()
    //   }, 1000) 
    // }
    // console.log('chainging ad')
    // this.setState({ showAd: false })
    // setTimeout(() => {
    //   this.setState({ showAd: true })
    // }, 1000)
  }

  componentDidMount() {
    // console.log('this.props.history,', this.props.history)
    // window.addEventListener('load', this.handleLoad);
  }

 


  render() {

    location.city.sort(function (a, b) {
      return a.localeCompare(b); 
    });

    location.state.sort(function (a, b) {
      return a.localeCompare(b); 
    });

    location.industry.sort(function (a, b) {
      return a.localeCompare(b); 
    });

   

    return (
      <footer className="app-footer " style={{ display: 'block' }}>
      <div className='footer-side d-flex '>
         <div className="footerItem align-self-end flex-column w-100"><span >&copy; {new Date().getFullYear()} Growjo</span><br /><span> All right reserved</span></div>
      </div>
      <div className='d-flex flex-grow-1 justify-content-center footer-big'>
      <div className='link-main col-12 col-md-6 pb-5'>
          <div className='link-head'><h3 className=''>Cities</h3></div>
          <div className='link'>
          {
            location.city.map((item, index) => {
              return (
                <Link key={'city' + index} to={`/city/${encodeforspace(item)}`} className="eachlink">{item}</Link>
              )
            })
          }
          </div>
          
        </div>
        <div className='link-main col pt-5 pt-sm-0'>
        <div className='link-head'><h3 className=''>States</h3></div>
          <div className='link'>
          {
            location.state.map((item, index) => {
              return (
                <Link key={'state' + index} to={`/state/${item}`} className="eachlink">{item}</Link>
              )
            })
          }
          </div>
          
         
        </div>
        <div className='link-main col'>
        <div className='link-head'> <h3 className=''>Industries</h3></div>
          <div className='link'>
          {
            location.industry.map((item, index) => {
              let industry = item;
              if (industry == 'Hospital/Healthcare') industry = 'Hospital_Healthcare'
              if (industry == 'Energy/Oil') industry = 'Energy_Oil'
              if (industry == 'Real Estate') industry = 'Real_Estate'
              if (industry == 'Tech Services') industry = 'Tech_Services'
              return (
                <Link key={'industry' + index} to={`/industry/${encodeforspace(industry)}`} className="eachlink">{item}</Link>
              )
            })
          }
          </div>
         
         
        </div>
        <div className='link-main col'>
        <div className='link-head'><h3 className=''>Growjo</h3></div>
          <div className='link'>
          <Link to='/directory'>Directory</Link>
          <Link to='/what-is-zoominfo'>What is ZoomInfo?</Link>
          <a href='https://www.lead411.com/blog/best-database-for-sales-leads-in-2023' target="_black">Best Sales Lead Database</a>
            

            
            <Link to='/terms'>Terms & conditions</Link>

          
          
            <Link to='/privacy'>Privacy Policy</Link>
          



          
            <Link to='/do_not'>Do Not Sell </Link>
            <Link to='/contact'>Contact Us </Link>
            <Link to='/about_our_data'>About our Data</Link>
          </div>
        </div>
      </div>
        
        {/* <div className='link'>
        <span>Countries:</span>
        {
          location.country.map((item, index)=>{
            return (
              <Link key={'country'+index} to={`/country/${item}`} className="eachlink">{item}</Link>
            )
          })
        }
        </div> */}
       

        {this.state.env != 'development' && <div id="drift-chat"></div>}
        <div className="col-md-12 text-center">
          
        </div>
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./client/src/components/Footer/Footer.js